module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showIEMessage) ? _c('no-internet-explorer', {
    on: {
      "close": _vm.closeIEMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-progress-bar'), _vm._v(" "), (_vm.getShowRichPrompt) ? _c('richPrompt') : _vm._e(), _vm._v(" "), _c('upgrade-plan-popup'), _vm._v(" "), _c('something-went-wrong-popup'), _vm._v(" "), _c('full-screen-loader', {
    attrs: {
      "active": _vm.getFullScreenLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app",
    class: {
      blurry: _vm.getFullScreenLoading
    }
  }, [_c('notifications', {
    attrs: {
      "position": "bottom right",
      "group": "notifications"
    }
  }), _vm._v(" "), _c(_vm.layout, {
    tag: "component"
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-007cd041", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007cd041"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1467
// module chunks = 0